import type {GenerateNameOptions} from '@wix/document-services-types'
import _ from 'lodash'

function isNamePrefixWithNumber(name: string, separator: string, prefix: string) {
    const separatorRegex = separator ? `[${separator}]?` : ''
    const r = new RegExp(`^${prefix}${separatorRegex}[0-9]*$`)
    return r.test(name)
}

function generateName(
    existingNames: string[] = [],
    {prefix, dontShowIndexForFirstName, separator = ''}: GenerateNameOptions = {}
) {
    const getNextIndex = () => {
        const highestIndexForName = _(existingNames)
            .filter(name => isNamePrefixWithNumber(name, separator, prefix))
            .map(name => _.replace(name, prefix, ''))
            .map(Number)
            .sortBy()
            .last()

        if (dontShowIndexForFirstName && highestIndexForName === undefined) {
            return undefined
        }
        return (highestIndexForName || 0) + 1
    }

    const nextIndex = getNextIndex()

    const suffix = nextIndex === undefined ? '' : `${separator}${nextIndex}`

    return `${prefix}${suffix}`
}

export default {
    generateName
}
